import { alpha, Chip, SvgIconProps } from "@mui/material"
import { blue, yellow } from "@mui/material/colors";
import { FaTruck } from "react-icons/fa";
import { GiCardPickup } from "react-icons/gi";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { chipOpacity, chipPadding } from "./common";
import MopedIcon from '@mui/icons-material/Moped';
import { IconWithText } from "./components";
import { DriverType } from "../../../interfaces/delivery-company/drivers";
import { DriverWithIcon } from "./driver-with-icon";
import { green, grey, orange, red, teal } from '@mui/material/colors';
import { AssignmentInd, LocalShipping, Cancel, PendingActions } from '@mui/icons-material';
import { DeliveryBatchState } from "../../../enums/tasks";


const icon = <LocalShippingIcon />
export const showDeliveryBatchChip = (deliveryBatchID: string, onClick?: () => void, driver?: DriverType): JSX.Element => {
    return <div style={onClick ? { cursor: "pointer" } : {}} onClick={onClick && ((e) => { e.stopPropagation(); onClick() })}>
        <Chip style={{ background: alpha(blue[200], chipOpacity), padding: chipPadding, fontWeight: "bold" }} icon={icon} label={`Batch #${deliveryBatchID}`} />
        <DriverWithIcon driver={driver} centered />
    </div>
}


export const getDeliveryBatchStateColor = (state: DeliveryBatchState): string => {
    switch (state) {
        case DeliveryBatchState.ASSIGNED:
            return alpha(orange[500], chipOpacity);
        case DeliveryBatchState.OUT_FOR_DELIVERY:
            return alpha(green[500], chipOpacity);
        case DeliveryBatchState.CANCELLED:
            return alpha(red[700], chipOpacity);
        default:
            return alpha(grey[700], chipOpacity);
    }
};

export const getDeliveryBatchStateIcon = (state: DeliveryBatchState): JSX.Element => {
    const iconProps: SvgIconProps = { fontSize: 'small', color: 'inherit' };

    switch (state) {
        case DeliveryBatchState.ASSIGNED:
            return <PendingActions {...iconProps} />;
        case DeliveryBatchState.OUT_FOR_DELIVERY:
            return <LocalShipping {...iconProps} />;
        case DeliveryBatchState.CANCELLED:
            return <Cancel {...iconProps} />;
        default:
            return <AssignmentInd {...iconProps} />;
    }
};

export const showDeliveryBatchState = (state: DeliveryBatchState): JSX.Element => {
    return (
        <Chip
            icon={getDeliveryBatchStateIcon(state)}
            label={<b>{state.toString().replaceAll("_", " ")}</b>}
            variant="filled"
            style={{
                backgroundColor: getDeliveryBatchStateColor(state),
            }}
        />
    );
};
